import styled, { css } from 'styled-components/macro'

import { settings } from '../../../../styled/settings/index';
import { mixins } from '../../../../styled/mixins/index';

const {
  colors: { color, hexToRGBa },
  mediaqueries: { mobileDown, tabletLandscapeDown, tabletPortraitDown, tabletPortraitUp },
  sizing: { spacingsize, radiussize },
  shadows: { buttonShadowDefault },
} = settings;

const {
  layout: { centered, centeredContent, fullContainerBackgroundImage, pageSection, pageSectionInner },
  typography: { buttonText, heading1, heading2, heading5, heroDescription, linkButtonText },
} = mixins;

const _containerHeightDesktop = `512px`;

const containerHeightDesktop = css`
  height: ${_containerHeightDesktop};

  @media ${tabletLandscapeDown} {
    height: ${_containerHeightDesktop};
  }
`;

export const Container = styled.div`
  display: grid;
  grid-template-columns: 50% calc(50% * .3333) calc(50% * .6666);
  grid-template-rows: 50% 50%;

  @media ${tabletLandscapeDown} {
    grid-template-columns: 30fr 30fr 40fr;
    grid-template-rows: 50fr 50fr;
  }

  @media ${mobileDown} {
    grid-template-columns: 65fr 35fr;
    grid-template-rows: 25fr 25fr 50fr;
  }
`;

export const ImageOne = styled.div`
  ${fullContainerBackgroundImage}
  max-width: 100%;
  grid-column-start: 1;
  grid-column-end: 2;
  grid-row-start: 1;
  grid-row-end: 3;

  @media ${tabletLandscapeDown} {
    height: auto;
    min-height: 256px;
    grid-column-start: 1;
    grid-column-end: 3;
    grid-row-start: 1;
    grid-row-end: 1;
  }

  @media ${mobileDown} {
    grid-column-start: 1;
    grid-column-end: 3;
    grid-row-start: 1;
    grid-row-end: 3;
  }
`;

const imageHeightDesktop = `calc(${_containerHeightDesktop} / 2)`;

export const ImageTwo = styled.div`
  ${fullContainerBackgroundImage}
  max-width: 100%;
  grid-column-start: 2;
  grid-column-end: 2;
  grid-row-start: 1;
  grid-row-end: 1;

  @media ${tabletLandscapeDown} {
    height: auto;
    min-height: 256px;
    grid-column-start: 1;
    grid-column-end: 1;
    grid-row-start: 2;
    grid-row-end: 2;
  }

  @media ${mobileDown} {
    height: auto;
    min-height: 128px;
    grid-column-start: 2;
    grid-column-end: 2;
    grid-row-start: 2;
    grid-row-end: 3;
  }
`;

export const ImageThree = styled.div`
  ${fullContainerBackgroundImage}
  max-width: 100%;
  grid-column-start: 2;
  grid-column-end: 2;
  grid-row-start: 2;
  grid-row-end: 2;

  @media ${tabletLandscapeDown} {
    height: auto;
    min-height: 256px;
    grid-column-start: 2;
    grid-column-end: 2;
    grid-row-start: 2;
    grid-row-end: 2;
  }

  @media ${mobileDown} {
    height: auto;
    min-height: 128px;
    grid-column-start: 2;
    grid-column-end: 3;
    grid-row-start: 1;
    grid-row-end: 2;
  }
`;

export const ContentCard = styled.div`
  grid-column-start: 3;
  grid-column-end: 3;
  grid-row-start: 1;
  grid-row-end: 3;
  background-color: ${color(`white`)};
  padding: 5rem;

  @media ${mobileDown} {
    height: auto;
    padding: 3rem;
    grid-column-start: 1;
    grid-column-end: 3;
    grid-row-start: 3;
    grid-row-end: 4;
  }
`;

export const Title = styled.h3`
  ${heading2}
  text-transform: uppercase;
  color: ${color(`black`)};
`;

export const Description = styled.div`
  ${heroDescription}
`;